module.exports = __webpack_public_path__ + "c2b2c28b98016afb2cb7e029c23f1f9f.woff2";